export const TransactionOperationTypeEnum = [
  { title: 'Sale', value: 0 },
  { title: 'Refund', value: 7 },
]
